import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input, OnChanges, OnInit } from '@angular/core';

export const ALL_TEXT_VARIANTS = [
  'sg-display-large-bold',
  'sg-display-medium-bold',
  'sg-heading-large-bold',
  'sg-heading-medium-bold',
  'sg-heading-small-bold',
  'sg-body-large-regular',
  'sg-body-medium-bold',
  'sg-body-medium-regular',
  'sg-body-small-bold',
  'sg-body-small-regular',
  'sg-body-xsmall-regular',
  'sg-label-large-regular',
  'sg-label-medium-regular',
  'sg-label-small-regular',
] as const;

type SgTextVariantOld =
  | 'sg-h1-mega'
  | 'sg-h1-hero'
  | 'sg-h2-standard'
  | 'sg-h3'
  | 'sg-h4'
  | 'sg-sub1'
  | 'sg-p1-small-letters'
  | 'sg-p2'
  | 'sg-p3-standard'
  | 'sg-p3-strong'
  | 'sg-p4-big-paragraph'
  | 'sg-button-large'
  | 'sg-button-medium'
  | 'sg-button-small';

type SgTextVariantNew = (typeof ALL_TEXT_VARIANTS)[number];

export type SgTextVariant = SgTextVariantNew | SgTextVariantOld;

export type SgTextPart = {
  variant: SgTextVariant;
  content: string;
  className?: string;
};

@Component({
  selector: 'sg-text',
  templateUrl: './sg-text.component.html',
  styleUrls: ['./sg-text.component.scss'],
  host: {
    '[style.color]': 'colorVariable',
    '[class]': 'variant',
    '[class.without-line-height]': 'withoutLineHeight',
  },
  standalone: false,
})
export class SgTextComponent implements OnInit, OnChanges {
  @Input() variant: SgTextVariant = 'sg-display-large-bold';
  @Input() color: string;
  @Input('withoutLineHeight') set _withoutLineHeight(value: BooleanInput) {
    this.withoutLineHeight = coerceBooleanProperty(value);
  }

  public withoutLineHeight: boolean = false;
  colorVariable: string = '';

  ngOnChanges(): void {
    this.updateColorVariable();
  }

  ngOnInit(): void {
    this.updateColorVariable();
  }

  private updateColorVariable(): void {
    if (this.color) {
      this.colorVariable = `var(--${this.color}, ${this.color})`;
    }
  }
}
